import _ from 'lodash';
import WineSkuConstants from '../constants/WineSkuConstants';
import PaginatedStore from './PaginatedStore';
import WineSku from '../models/WineSku';

class WineSkuStore extends PaginatedStore {
  static storeName = 'WineSkuStore';
  static handlers = {
    [WineSkuConstants.FETCH_WINE_SKU_START]   : 'fetchEntityStart',
    [WineSkuConstants.FETCH_WINE_SKU_SUCCESS] : 'fetchEntitySuccess',
    [WineSkuConstants.FETCH_WINE_SKU_FAILURE] : 'fetchEntityFailure',
    [WineSkuConstants.LIST_WINE_SKUS_START]    : 'listEntitiesStart',
    [WineSkuConstants.LIST_WINE_SKUS_SUCCESS]  : 'listEntitiesSuccess',
    [WineSkuConstants.LIST_WINE_SKUS_FAILURE]  : 'listEntitiesFailure'
  };
  static defaultPagination = { offset: 0, limit: 30 };
  static defaultSorter = { key: 'created_at', direction: 'desc' };
  static entityModel = WineSku;

  constructor(dispatcher) {
    super(dispatcher);

    this.suggestedFilters = [];
  }

  listEntitiesStart(data) {
    super.listEntitiesStart(data);
  }

  listEntitiesSuccess(data) {
    if(!_.isEqual(data.sorter, this.currentSorter) || !_.isEqual(data.filters, this.currentFilters)) {
      return;
    }

    this.suggestedFilters = data.suggestedFilters;
    super.listEntitiesSuccess(data);
  }

  getCurrentSearchState() {
    return {
      wineSkus: this.orderedEntities,
      suggestedFilters: this.suggestedFilters,
      filters: this.currentFilters,
      sorter: this.currentSorter,
      pagination: this.currentPagination,
      loading: this.loading
    };
  }

  dehydrate() {
    return _.extend(super.dehydrate(), {
      suggestedFilters: this.suggestedFilters
    });
  }

  rehydrate(state) {
    super.rehydrate(state);
    this.suggestedFilters = state.suggestedFilters;
  }
}

export default WineSkuStore;



// WEBPACK FOOTER //
// banquet/stores/WineSkuStore.js